import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

// const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoz0DIA6hCUshJTmqGsPhfOVYPaz1ANp+LiZg+QixE3bATVzGDwNfzbQjOOMS2SPNmbVOVp662KMJS1PI0LRLJgGYKCORrfsbZC24gHuT3B6pii95Qo6MsXXthkmjp8+8kxF827kfpNJEGkb65pgPDO0ZFU2wLYBj7cduzvqWEfiEhyr8uV74WBX/7DSFINvuzTd7n08Y9saNLYsfBU38JG1LOx5nzxRhmV/tq35PIWNbcPC9OGYk0LVBn1ODKRLq2OtYhEkhD+agKThH2TfND2cqjAxOlHtglcoS/qNW0Rx15a5v800Aa8rPaxf8eR0XYRDekNG68Dbe3ZNFW0xH+QIDAQAB'
//
// const privateKey = 'MIIBVAIBADANBgkqhkiG9w0BAQEFAASCAT4wggE6AgEAAkEA3HWEZzUNiFuWHN7k\n' +
//     'M4/rRQSXdcrbbwFEdjaMAXUWq26/T0MIwpy44hgLTYOTZIc6CqCEAsS5HupaAr81\n' +
//     'WZ+D0QIDAQABAkBdhrF8A2LRVWFysBCJ22WJKzCCNWQwTI5ZxDxTJfRPF2wJdVc+\n' +
//     'vnwBLiHnZsgHRjyPSGEku0v0udPiK9tGpX7BAiEA86Y4e1Fz8G3ncwZOusWjNsPI\n' +
//     'qJF0zf7GzpNYSnsdaSkCIQDnoly5ZgVDI7kWjladp4jB5dBLNpA6PMRzpt8JRKaS\n' +
//     'aQIhANLKvNTbvF2HCBV4oIZv1Gvd6G0GIrLRODiiO2F8sA45AiBzaK0EXrVuf0T/\n' +
//     '3QmA4XE9EpDWeKghrBdBfDoSNxc7SQIgSuN0dCVlBSnpFnqqZTQR266WyjDVPZSO\n' +
//     'ltn1HPuyiuc='
const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKoR8mX0rGKLqzcWmOzbfj64K8ZIgOdH\n' +
  'nzkXSOVOZbFu/TJhZ7rFAN+eaGkl3C4buccQd/EjEsj9ir7ijT7h96MCAwEAAQ=='

const privateKey = 'MIIBVAIBADANBgkqhkiG9w0BAQEFAASCAT4wggE6AgEAAkEAqhHyZfSsYourNxaY\n' +
  '7Nt+PrgrxkiA50efORdI5U5lsW79MmFnusUA355oaSXcLhu5xxB38SMSyP2KvuKN\n' +
  'PuH3owIDAQABAkAfoiLyL+Z4lf4Myxk6xUDgLaWGximj20CUf+5BKKnlrK+Ed8gA\n' +
  'kM0HqoTt2UZwA5E2MzS4EI2gjfQhz5X28uqxAiEA3wNFxfrCZlSZHb0gn2zDpWow\n' +
  'cSxQAgiCstxGUoOqlW8CIQDDOerGKH5OmCJ4Z21v+F25WaHYPxCFMvwxpcw99Ecv\n' +
  'DQIgIdhDTIqD2jfYjPTY8Jj3EDGPbH2HHuffvflECt3Ek60CIQCFRlCkHpi7hthh\n' +
  'YhovyloRYsM+IS9h/0BzlEAuO0ktMQIgSPT3aFAgJYwKpqRYKlLDVcflZFCKY7u3\n' +
  'UP8iWi1Qw0Y='

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 用指定公钥加密
export function userEncrypt(txt, pbcKey) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(pbcKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey) // 设置私钥
  return encryptor.decrypt(txt) // 对数据进行解密
}

